import { useRef } from "react";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import AgitationSection from "@/components/AgitationSection";
import SelectorSection from "@/components/SelectorSection";
import GoogleReviewsSection from "@/components/GoogleReviewsSection";
import InstagramFeedSection from "@/components/InstagramFeedSection"; // Import the new component
import BlogSection from "@/components/BlogSection";

import QuoteSection from "@/components/QuoteSection";
import Footer from "@/components/Footer";

const Index = () => {
  const heroSectionRef = useRef<HTMLDivElement>(null);

  return (
    <div className="relative">
      <Header />

      {/* PART 1 - Top Half */}
      <HeroSection ref={heroSectionRef} />
      <AgitationSection />
      <GoogleReviewsSection />
      <SelectorSection />
      <BlogSection />
      <InstagramFeedSection />

      {/* PART 2 - Bottom Half */}



      <QuoteSection />

      <Footer />
    </div>
  );
};

export default Index;
